// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1pmKy","boxTitle":"Qualiphy_boxTitle__1EKbS","box":"Qualiphy_box__Vi16A","toggleWrap":"Qualiphy_toggleWrap__2yGzI"};